import { Button as AntdButton, type ButtonProps } from 'antd';
import { forwardRef } from 'react';

// TODO(design): Update danger variant theming to match design system
// Issue: none

const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  return <AntdButton ref={ref} {...props} />;
});

Button.displayName = 'Button';

export default Button;
